module.exports = __webpack_public_path__ + "media/images/emblems/Magliaso-coat_of_arms-bc33daa3e5ec13c789e70fcd9fd2799c.svg";